/**
 * @generated SignedSource<<ed237ec2966bbe0429edb96b787204be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormattingOld_savedView_rules">;
  readonly " $fragmentType": "IssueRow_rules";
};
export type IssueRow_rules$key = {
  readonly " $data"?: IssueRow_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow_rules",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormattingOld_savedView_rules"
        }
      ]
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "7f54e3788a3fd5f88742103d942f99e2";

export default node;
